export enum TelematicsDelegationFilter {
  ALL = 'all',
  ACTIVE = 'active',
  NONE = 'none',
}
